// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__3FhoA","App-logo":"App_App-logo__3J6-U","App-logo-spin":"App_App-logo-spin__2W7qw","App-header":"App_App-header__k-FZf","App-link":"App_App-link__PbEHU"};